var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CoreConnectionInstance } from "./CoreConnectionInstance.js";
import { isEqual } from "lodash";
import "../components/physics/Physics.js";
import "../components/types.js";
import "../enums-86f58524.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../global-33d5eebf.js";
import "../components/ComponentRegistry.js";
import "../utils/byteArray.js";
import "../components/entity/Types.js";
import "@dimforge/rapier2d-compat";
import "../console/flags.js";
import "../persist/persist.js";
import "../console/editor.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
import "pixi.js";
import "../FrameRate-7ce72a03.js";
import "../Collisions-9e9492fb.js";
import "../Physics-8d447f7a.js";
import "../game/GameModel.js";
import "../entity/EntityFactory.js";
import "../constants/index.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "../Parent-b4f1af10.js";
import "../components/core/ListenEntityCreation.js";
import "../Random-b6daba3a.js";
import "../SpatialMap-56228ece.js";
import "../ui/UIService.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../utils/md5.js";
import "../TimeDilation-41a74cd7.js";
import "nanoid";
import "../inputs/TouchListener.js";
import "../inputs/PlayerEventManager.js";
import "../game/GameCoordinator.js";
import "pixi-viewport";
import "../game/Ticker.js";
import "../PlayerInput-ad722e2d.js";
class WsSocketMultiplayerInstance extends CoreConnectionInstance {
  constructor(player, inputManager, options) {
    super(player, inputManager, options);
    __publicField(this, "socket");
    __publicField(this, "connectionPromise");
    __publicField(this, "pingInterval");
    __publicField(this, "pingStart");
    this.options = options;
    const host = this.options.host.startsWith("localhost") ? `ws://${this.options.host}` : `wss://${this.options.host}`;
    this.socket = new WebSocket(host);
    this.connectionPromise = new Promise((resolve) => {
      this.socket.addEventListener("open", () => {
        this.player.connectionId = this.player.netId;
        this.player.connected = true;
        this.lazyEmit("join", [this.options.address, this.player.connectionId, this.player]);
        this.pingInterval = setInterval(() => {
          this.pingStart = Date.now();
          this.socket.send("ping[]");
        }, 1e3);
        resolve();
      });
    });
  }
  lazyEmit(event, args) {
    this.socket.send(event + JSON.stringify(args));
  }
  emit(event, ...args) {
    this.lazyEmit(event, args);
    if (event !== "message" && event !== "peer") {
      this.handleData([event, ...args]);
    }
  }
  handleData(data) {
    let [event, ...args] = data;
    if (event === "peer") {
      args[0];
      const player = args[1];
      if (!this.players.find((p) => p.netId === player.id)) {
        this.players.push(player);
        this.handleData(["connect", player]);
        if (player.id !== this.player.netId) {
          this.emit("peer", this.player.connectionId, this.player);
        }
      } else if (player.id !== this.player.netId) {
        const currentPlayer = this.players.find((p) => p.netId === player.id);
        if (!isEqual(currentPlayer, player)) {
          this.players = this.players.map((p) => p.netId === player.id ? player : p);
          this.handleData(["reconnect", player]);
          if (player.id !== this.player.netId) {
            this.emit("peer", this.player.connectionId, this.player);
          }
        }
      } else {
        this.handleData(["connect", player]);
      }
      return;
    }
    if (this.onceSubscriptions[event]) {
      this.onceSubscriptions[event].forEach((callback) => {
        callback(...args);
      });
      this.onceSubscriptions[event] = [];
    }
    if (this.subscriptions[event]) {
      this.subscriptions[event].forEach((callback) => {
        callback(...args);
      });
    }
  }
  async connect() {
    super.connect();
    this.socket.onmessage = (event) => {
      if (typeof event.data !== "string") {
        return;
      }
      if (event.data.startsWith("pong")) {
        const room = this.roomStates[this.player.currentRoomId ?? ""];
        if (room == null ? void 0 : room.gameModel) {
          room.gameModel.ping = Date.now() - this.pingStart;
        }
        return;
      }
      const eventName = event.data.substring(0, event.data.indexOf("["));
      const data = JSON.parse(event.data.substring(eventName.length));
      this.handleData([eventName, ...data]);
    };
    await this.connectionPromise;
    return Promise.resolve();
  }
}
export {
  WsSocketMultiplayerInstance
};
//# sourceMappingURL=WsSocketMultiplayerInstance.js.map
